module.exports = __webpack_public_path__ + "static/media/kayan_background.0bc0ad2f.jpg";